import React, { useState, useEffect, useContext } from "react";
import { useNavigate, Link, useLocation  } from 'react-router-dom';


const Footer = ( params ) => {
// console.log( params );
	return (
		<>

		<div className="footer" style={{ paddinLeft: '0px', marginTop: '20px' }}>
						<div className="copyright" style={{ textAlign: 'center' }}>
							Contact us: info@diamta.com | Copyright &copy; Diamta 2025
						</div>
					</div>
		</>
	);
};

export default Footer;
